import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { IconCloseSvg } from 'apps/sigma2-ui/src/components/svg/IconClose';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const RubricTagPill: React.FC<{
  name: string;
  onRemove?: () => void;
}> = ({ name, onRemove }) => {
  const language = useLanguage();
  return (
    <div className="rounded-lg bg-indigo-200 px-4 py-3 flex justify-center items-center w-fit max-w-32">
      <Spacing
        direction="horizontal"
        size="sm"
        className="items-center truncate"
      >
        <S2Typography
          variant="headline-6-alt"
          textColorVariant="indigo-1000"
          translatedContent={[
            {
              text: name,
              tooltip: name,
            },
          ]}
          truncate
        />
        {onRemove && (
          <TouchTarget
            className="text-indigo-1000"
            behavior={{
              type: 'onClick',
              onClick: onRemove,
            }}
            content={() => <IconCloseSvg svg={{ className: 'w-4 h-4' }} />}
            label={language.remove()}
          />
        )}
      </Spacing>
    </div>
  );
};
